/**
 * Base CRUD model
 *
 * @param {ApiHelper} api
 */
export default class BaseCrudRequests {
    baseUrl = '/some-sample-base-url';

    constructor(api) {
        this.api = api;
    }


    async list(errorHandler) {
        const url = this.baseUrl;

        const response = await this.api.getRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async view(pk, errorHandler) {
        const url = this.baseUrl+'/' + pk;

        const response = await this.api.getRequest(url);

        return this.processResponse(response, errorHandler);
    }


    async create(data, errorHandler) {
        const url = this.baseUrl;

        const response = await this.api.postRequest(url, data);

        return this.processResponse(response, errorHandler);
    }


    async update(pk, data, errorHandler) {
        const url = this.baseUrl+'/' + pk;

        const response = await this.api.postRequest(url, data);

        return this.processResponse(response, errorHandler);
    }


    async delete(pk, errorHandler) {
        const url = this.baseUrl+'/' + pk;

        const response = await this.api.deleteRequest(url);

        return this.processResponse(response, errorHandler);
    }


    processResponse(response, errorHandler) {
        if (response.status.toString().startsWith('20') && response.data && response.data.success === true && response.data.data) {
            return response.data.data;
        } else {
            if (errorHandler) {
                return errorHandler(response.data);
            }
        }

        return false;
    }
}